'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import FilesTrashLink from 'FileManagerCore/components/FilesTrashLink';
import UIList from 'UIComponents/list/UIList';
import ArchiveFilter from './ArchiveFilter';
import Search from './Search';
import FileTypeFilter from './FileTypeFilter';
import ExportFilesAndButtonsContainer from './ExportFilesAndButtonsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DashboardActionBar(props) {
  const {
    onFetchSearch,
    onArchiveFilterChange,
    onFileTypeFilterChange,
    isStartState,
    isArchivedFilterApplied
  } = props;
  const searchBar = isStartState && !isArchivedFilterApplied ? null : /*#__PURE__*/_jsx(Search, {
    className: "m-right-2",
    onFetchSearch: onFetchSearch,
    placeholder: I18n.text('FileManagerDashboard.toolbar.searchPlaceholder')
  }, "search");
  const actionButtons = isStartState ? null : /*#__PURE__*/_jsxs(UIList, {
    inline: true,
    children: [/*#__PURE__*/_jsx(ExportFilesAndButtonsContainer, {}), /*#__PURE__*/_jsx(FilesTrashLink, {})]
  });
  return /*#__PURE__*/_jsx(UIFilterBar, {
    startSlot: [searchBar, /*#__PURE__*/_jsx(FileTypeFilter, {
      onChange: onFileTypeFilterChange
    }, "file-type-filter"), /*#__PURE__*/_jsx(ArchiveFilter, {
      onChange: onArchiveFilterChange
    }, "archive-filter")],
    endSlot: actionButtons
  });
}
DashboardActionBar.propTypes = {
  isStartState: PropTypes.bool,
  isArchivedFilterApplied: PropTypes.bool.isRequired,
  onFetchSearch: PropTypes.func.isRequired,
  onArchiveFilterChange: PropTypes.func.isRequired,
  onFileTypeFilterChange: PropTypes.func.isRequired
};